import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'syr-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
